import productService from "../../../../services/ProductService"
import productImageService from "../../../../services/ProductImageService"
import Notify from "../../../../elements/Notify"
import Dialog from "../../../../elements/Dialog"

export default {
   name: 'ProductList',
   data() {
      return {
         product: {
            id  : '',
            name: ''
         },
         productImage: {
            id         : '',
            src        : '',
            filename   : '',
            main_status: true,
            product_id : '',
            created_at : '',
            file       : null
         },
         imagesData: [],
         mainImage : null
      }
   },
   beforeRouteEnter(to, from, next) {
      productService.getProductById(to.params.productId)
         .then((snapshot) => {
            let product = snapshot.val()
            if (product != null) {
               next(vm => vm.setProduct(product))
            }
            else {
               next({ name: 'products' })
            }
         })
         .catch(() => {
            Notify.error("No existe el producto.")
            next({ name: 'products' })
         })
   },
   created() {
      this.$store.dispatch('title', 'Imágenes del producto')
   },
   methods: {
      addedImage(file) {
         this.productImage.file = file
      },
      saveProductImage() {
         let productImage = this.getProductImage()
         productImageService.storeProductImage(productImage)
            .then(() => {
               Notify.success("Se registro correctamente.")
               this.resetForm()
            })
            .catch((e) => {
               Notify.error(e)
            })
      },
      getProductImage() {
         return {
            id         : this.productImage.id,
            src        : this.productImage.src,
            filename   : this.productImage.filename,
            main_status: this.imagesData.length > 0 ? '0' : '1',
            product_id : this.productImage.product_id,
            created_at : this.productImage.created_at,
            file       : this.productImage.file
         }
      },
      getDataDefaultProductImage() {
         return {
            id         : '',
            src        : '',
            filename   : '',
            main_status: true,
            product_id : this.product.id,
            created_at : '',
            file       : null
         }
      },
      deleteProductImage(productImage) {
         Dialog.confirm('Eliminar', '¿Esta seguro de querer eliminar este característica? No se podrá recuperar esta información nuca mas.')
            .then(() => {
               this.resetForm()
               productImageService.deleteProductImage(productImage)
                  .then(() => {
                     Notify.success("Se eliminó correctamente.")
                  })
                  .catch((e) => {
                     Notify.error(e)
                  })
            })
            .catch(() => {
               Notify.info("Gracias por no eliminarme.")
            })
      },
      changeMainImage(productImage) {
         productImageService.updateMainStatus(productImage, this.mainImage)
            .then(() => {
               Notify.success("Se cambio de imagen principal.")
               this.mainImage = productImage
            })
            .catch((e) => {
               Notify.error(e)
            })
      },
      setProduct(product) {
         this.product.id = product.id
         this.product.name = product.name

         this.productImage = this.getDataDefaultProductImage()

         productImageService.getRefByProduct(this.product.id).on('value', snapshot => {
            this.setImagesData(snapshot.val())
         })
      },
      setImagesData(data) {
         this.imagesData = []
         for (const key in data) {
            if (data.hasOwnProperty(key)) {
               const element = data[key]
               this.imagesData.push(element)

               if (element.main_status == '1') {
                  this.mainImage = element
               }
            }
         }
      },
      resetForm() {
         this.productImage = this.getDataDefaultProductImage()
         this.$refs.uploaderFile.reset();
      }
   }
}
